/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DashboardResource } from '../models/DashboardResource'

import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class DashboardService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * The current Helm user's dashboard. Returns an empty `layout` if one has never been saved.
     * @returns any OK
     * @throws ApiError
     */
    public getDashboard(): CancelablePromise<{
        data: DashboardResource
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/dashboard',
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Replaces the current Helm user's whole dashboard layout.
     * @returns any OK
     * @throws ApiError
     */
    public updateDashboard({
        requestBody
    }: {
        requestBody?: {
            layout: Array<Record<string, any>>
        }
    }): CancelablePromise<{
        data: DashboardResource
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/dashboard',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }
}
